"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { initMixpanel, trackPageView } from "@/lib/mixpanel";

export function MixpanelTracker() {
  const pathname = usePathname();

  // Initialize once on mount
  useEffect(() => {
    initMixpanel();
  }, []);

  // Track every route change
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
